import { useState } from "react";
import type { StopwatchSettings } from "../../types/timer-settings";
import { ToggleSwitch, SoundConfigRow } from "./TimerSettingsAtoms";

interface StopwatchSettingsSectionProps {
  readonly settings: StopwatchSettings;
  readonly onUpdate: (patch: Partial<StopwatchSettings>) => void;
}

export function StopwatchSettingsSection({ settings, onUpdate }: StopwatchSettingsSectionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-surface-alt hover:bg-surface-alt/80 text-sm font-semibold text-ink"
      >
        <span>Chronometre</span>
        <span className="text-ink-muted text-xs">{expanded ? "▲" : "▼"}</span>
      </button>

      {expanded && (
        <div className="px-4 py-3 flex flex-col gap-4">
          <ToggleSwitch
            label="Afficher les millisecondes"
            checked={settings.showMilliseconds}
            onChange={(v) => onUpdate({ showMilliseconds: v })}
          />
          <SoundConfigRow
            label="Son de tour"
            config={settings.lapSound}
            onChange={(v) => onUpdate({ lapSound: v })}
          />
        </div>
      )}
    </div>
  );
}
